export var BuiltinContextAttachmentKinds = [
    'webSnippet',
    'formSnapshot',
    'formField',
];
//# sourceMappingURL=context.js.map